<template>
  <div class="w-full h-[300px] text-white overflow-hidden flex flex-col gap-3">
    <div class="px-10 py-3 flex flex-col gap-3" :class="{'bg-slate-950/20 py-4 xl:py-3': expanded !== 'valores'}">
      <div class="flex flex-row items-center">
        <button class="grow flex flex-row items-center" v-if="expanded !== 'valores'"
                @click="() => {expanded = 'valores'; getValores()}">
          <span class="font-poppins font-bold text-sm xl:text-lg grow text-left truncate">Valores</span>
          <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
        </button>
        <span v-else class="font-poppins font-bold text-sm xl:text-lg grow truncate">Valores</span>
        <div v-if="expanded === 'valores'">
          <div class="actions flex flex-row gap-2 text-xs">
            <RouterLink :to="{path: '/pagina/valores', name: 'valores'}"
                        class="rounded-full h-7 w-7 pt-1.5 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-plus"></i>
            </RouterLink>
            <button :disabled="valores.paginaAnteriorDesabilitada" @click="getValores(valores.paginaAnterior)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-angle-left"></i>
            </button>
            <button :disabled="valores.proximaPaginaDesabilitada" @click="getValores(valores.proximaPagina)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/15">
              <i class="fa-solid fa-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="expanded === 'valores'" class="grid grid-cols-3 grid-rows-2 gap-3">
        <template v-if="loadingValores">
          <Sk v-for="i in 6" :key="i" w="100%" h="80px" rounded="rounded-md" extra="bg-white/20" />
        </template>
        <template v-else v-for="(valor, index) in valores.mobis"
                  :key="index">
          <router-link v-if="index < 6" :to="{path: '/pagina/valores', name: 'valores', query: { s: valor?.mob }}"
                       class="bg-slate-950/10 rounded-md relative overflow-hidden  min-h-[80px] w-full h-[80px]  max-h-[80px]">
            <div class="mob bg-slate-950/10 flex flex-col items-center justify-center h-[50px]">
              <img :src="valor?.icon" />
            </div>
            <div class="flex flex-row px-2 py-1.5 relative" v-if="valor?.preco">
              <div class="valor flex flex-row items-center gap-1">
                <img src="@/assets/asinha.png" alt="asinha" class="h-4 w-4">
                <span class="font-semibold text-xs">{{ valor?.preco }}</span>
              </div>
              <div
                class="absolute right-1 -top-3 w-6 h-6 rounded-full overflow-hidden flex flex-col items-center text-xs py-1 shadow-md"
                :class="{up: valor?.stats === '1', down: valor?.stats === '2', stable: valor?.stats === '3'}">
                <span class="stats" v-if="valor?.stats == '1'"><i class="fa-solid fa-arrow-trend-up"></i></span>
                <span class="stats" v-else-if="valor?.stats == '2'"><i class="fa-solid fa-arrow-trend-down"></i></span>
                <span class="stats" v-else><i class="fa-solid fa-grip-lines"></i></span>
              </div>
            </div>

          </router-link>
        </template>
      </div>
    </div>
    <div class="px-10 flex flex-col gap-3" :class="{'bg-slate-950/20 py-4 xl:py-3': expanded !== 'recordes'}">
      <div class="flex flex-row items-center">
        <button class="w-full flex flex-row items-center" v-if="expanded !== 'recordes'"
                @click="() => {expanded = 'recordes'; getRecordes()}">
          <span class="font-poppins font-bold text-sm xl:text-lg grow text-left truncate">Recordes</span>
          <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
        </button>
        <span v-else class="font-poppins font-bold text-sm xl:text-lg grow truncate">Recordes</span>
        <div v-if="expanded === 'recordes'">
          <div class="actions flex flex-row gap-2 text-xs">
            <RouterLink :to="{path: '/pagina/recordes', name: 'recordes'}"
                        class="rounded-full h-7 w-7 pt-1.5 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-plus"></i>
            </RouterLink>
            <button :disabled="recordes.paginaAnteriorDesabilitada" @click="getRecordes(recordes.paginaAnterior)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-angle-left"></i>
            </button>
            <button :disabled="recordes.proximaPaginaDesabilitada" @click="getRecordes(recordes.proximaPagina)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/15">
              <i class="fa-solid fa-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="expanded === 'recordes'" class="grid grid-cols-3 grid-rows-2 gap-3">
        <template v-if="loadingRecordes">
          <Sk v-for="i in 6" :key="i" w="100%" h="80px" rounded="rounded-md" extra="bg-white/20" />
        </template>
        <template v-else v-for="(recorde, index) in recordes.mobis"
                  :key="index">
          <router-link v-if="index < 6" :to="{path: '/pagina/recordes', name: 'recordes', query: { s: recorde?.name }}"
                       class="bg-slate-950/10 rounded-md relative overflow-hidden  min-h-[80px] w-full h-[80px]  max-h-[80px]">
            <div class="mob bg-slate-950/10 flex flex-col items-center justify-center h-[50px]">
              <img v-if="recorde?.code"
                :src="`https://images.habblet.city/library/hof_furni/icons/${recorde.code}_icon.png`"
                :onerror="`this.onerror=null;this.src='${recorde.imagem_mob}'`"
              />
              <img v-else-if="recorde?.imagem_mob" :src="recorde.imagem_mob" />
            </div>
            <div class="flex flex-row px-2 py-1.5 relative" v-if="recorde?.itens != null">
              <div class="valor flex flex-row items-center gap-1">
                <img src="@/assets/medal.png" alt="medal">
                <span class="font-semibold text-xs">{{ recorde?.itens }}</span>
              </div>
            </div>

          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getMobs, getRecords } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'

import { onMounted, reactive, ref } from 'vue'

const expanded = ref('valores')
const loadingValores = ref(true)
const loadingRecordes = ref(true)
const valores = reactive({
  mobis: [],
  proximaPagina: 0,
  proximaPaginaDesabilitada: true,
  paginaAnterior: 0,
  paginaAnteriorDesabilitada: true
})

const recordes = reactive({
  mobis: [],
  proximaPagina: 0,
  proximaPaginaDesabilitada: true,
  paginaAnterior: 0,
  paginaAnteriorDesabilitada: true
})

async function getValores(pagina = 1) {
  loadingValores.value = true
  const data = await getMobs({ pag: pagina })
  valores.mobis = data.valores ?? []
  valores.paginaAnterior = data.prev ?? 0
  valores.proximaPagina  = data.next ?? 0
  valores.paginaAnteriorDesabilitada = parseInt(data.prev) === 0
  valores.proximaPaginaDesabilitada  = data.next === 0
  loadingValores.value = false
}

async function getRecordes(pagina = 1) {
  loadingRecordes.value = true
  const data = await getRecords({ pag: pagina })
  recordes.mobis = data.record ?? []
  recordes.paginaAnterior = data.prev ?? 0
  recordes.proximaPagina  = data.next ?? 0
  recordes.paginaAnteriorDesabilitada = parseInt(data.prev) === 0
  recordes.proximaPaginaDesabilitada  = data.next === 0
  loadingRecordes.value = false
}

onMounted(() => {
  getValores()
  getRecordes()
})

</script>

<style scoped>
.up {
  background-color: #4CAF50;
}

.stable {
  background-color: #4c6daf;
}

.down {
  background-color: #f44336;
}

</style>
